import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class CmxInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const cmxHeaders = {
      Accept: 'application/json',
      'App-Code': 'Foreman_App',
      'Accept-Language': localStorage.getItem('language') || 'en-US',
      'x-ibm-client-id': window['CLIENT_ID'] // This is for params request
    };

    const headerKeys = req.headers.keys() || [];
    for (const key of headerKeys) {
      cmxHeaders[key] = req.headers.get(key);
    }

    req = req.clone({
      setHeaders: cmxHeaders
    });

    return next.handle(req);
  }
}